import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  chip: {
    color: 'rgba(44, 45, 62, 0.7)',
    margin: 2,
  },
  avatar: {
    '&.MuiChip-avatar.MuiChip-avatarSmall': {
      marginLeft: '5px',
      width: '15px',
    },
  },
}));
